import { render, staticRenderFns } from "./TheStepsServiceTabs.vue?vue&type=template&id=63fcde92&"
import script from "./TheStepsServiceTabs.vue?vue&type=script&lang=js&"
export * from "./TheStepsServiceTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports